//Cart terms begin

function updateCartTerms(checked) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: "attributes[Terms]=" + (checked ? "Yes" : "no")
    });
}
if(document.getElementById("CartTerms")){
	document.getElementById("CartTerms").addEventListener("change", function() {
		updateCartTerms(this.checked);
	});	
}

if(document.getElementById("CartTermsDrawer")){
	document.getElementById("CartTermsDrawer").addEventListener("change", function() {
		updateCartTerms(this.checked);
	});
}

document.addEventListener("DOMContentLoaded", function() {
    addCheckoutEvent();
    setTimeout(addCheckoutEvent, 100);
    setTimeout(addCheckoutEvent, 500);
    setTimeout(addCheckoutEvent, 1000);
    setTimeout(addCheckoutEvent, 2000);

	document.getElementById("headerCartStatus").addEventListener("click", function() {
		addCheckoutEvent();		
		setTimeout(() => {
			document.getElementById("CartTermsDrawer").addEventListener("change", function() {
				updateCartTerms(this.checked);			
			});
		}, 500);
	});
});


function addCheckoutEvent() {
    var submitBtns = document.querySelectorAll(".js-cart-drawer-submit-btn, .submit-btn");
    submitBtns.forEach(function(submitBtn) {
		console.log("checkout event activated")
        submitBtn.addEventListener("click", function(e) {
            var error = false;
            var formFooter = this.closest(".cart-conditions-container");
            if (formFooter) {
                var formFields = formFooter.querySelectorAll(".form-field");
                formFields.forEach(function(formField) {
                    if (formField.classList.contains('form-field--checkbox')) {
                        var checkbox = formField.querySelector('input[type=checkbox]');
						console.log(checkbox)
                        if (checkbox && checkbox.checked === false && checkbox.classList.contains("required")) {
                            formField.classList.add("error");
                            error = true;

                        } else {
                            formField.classList.remove("error");
                        }
                    } else {
                        var input = formField.querySelector('input, textarea');
                        if (input && input.value === '' && input.classList.contains("required")) {
                            formField.classList.add("error");
                            error = true;
                        } else {
                            formField.classList.remove("error");
                        }
                    }
                });
            }
            if (error) {
                e.preventDefault();
            }
        });
    });
}
//Cart terms end

document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('click', function(event) {
        if (event.target.closest('.product__info--collapse h2')) {
            var area = event.target.closest('.product__info--collapse').parentNode;
            var content = event.target.nextElementSibling;

            if (!event.target.classList.contains('active')) {
                var otherContents = area.querySelectorAll('.product__info__content');
                otherContents.forEach(function(item) {
                    item.style.transition = 'height 0.5s';
                    item.style.height = '0px';
                });
                content.style.transition = 'height 0.5s';
                content.style.height = getContentHeight(content) + 'px';
            } else {
                content.style.transition = 'height 0.5s';
                content.style.height = '0px';
            }

            var otherHeaders = area.querySelectorAll('h2');
            otherHeaders.forEach(function(item) {
                if (item !== event.target) {
                    item.classList.remove('active');
                }
            });
            event.target.classList.toggle('active');
        }
    });
});

function getContentHeight(element) {
    var height = element.scrollHeight;
    var style = getComputedStyle(element);
    height += parseInt(style.paddingTop) + parseInt(style.paddingBottom);
    return height;
}


// Grid 100 vh

function resetHeight() {
    // reset the body height to that of the inner browser
    var siteHeaderHeight = document.querySelector(".header").offsetHeight;
   
	var js100vhHeading = document.querySelector(".js-100vh-heading");
	var js100vh = document.querySelector(".js-100vh");
	var js50vh = document.querySelector(".js-50vh");
	// Set the height only if the elements exist
	if (js100vhHeading) {
		js100vhHeading.style.height = "calc(" + window.innerHeight + "px - " + siteHeaderHeight + "px)";
	}
	if (js100vh) {
		js100vh.style.height = "calc(" + window.innerHeight + "px)";
	}
	if (js50vh) {
		js50vh.style.height = "calc(" + (window.innerHeight / 2) + "px)";
	}
    
}

document.addEventListener("DOMContentLoaded", function() {
    resetHeight();
    setTimeout(resetHeight, 1000);
});
